import { loadProfile } from '../content/loadProfile'

export default function Nav() {
  const profile = loadProfile()

  return (
    <nav className="nav" data-testid="nav" aria-label="Primary">
      <a className="nav__brand" href="#home" data-testid="nav-home">
        {profile.displayName}
      </a>
      <ul className="nav__links">
        <li>
          <a href="#work" data-testid="nav-work">
            Work
          </a>
        </li>
        <li>
          <a href="#contact" data-testid="nav-contact">
            Contact
          </a>
        </li>
      </ul>
    </nav>
  )
}
